import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition', {
    attrs: {
      "name": "assistant-slide"
    }
  }, [_c('aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOpen,
      expression: "isOpen"
    }],
    staticClass: "assistant-chat",
    class: [_vm.$vuetify.theme.dark ? 'theme--dark' : 'theme--light', {
      'assistant-chat--tasks-collapsed': _vm.tasksCollapsed,
      'assistant-chat--fullscreen': _vm.$vuetify.breakpoint.smAndDown
    }],
    style: _vm.accentStyle,
    attrs: {
      "data-cy": _vm.dataCy,
      "role": "complementary",
      "aria-label": "niotix AI assistant"
    }
  }, [_c('header', {
    staticClass: "assistant-chat__header"
  }, [_c('div', {
    staticClass: "assistant-chat__header-icon"
  }, [_c(VIcon, {
    attrs: {
      "small": "",
      "color": _vm.accentTextColor
    }
  }, [_vm._v("fal fa-robot")])], 1), _c('div', {
    staticClass: "assistant-chat__header-text"
  }, [_c('div', {
    staticClass: "assistant-chat__title-row"
  }, [_c('span', {
    staticClass: "assistant-chat__title"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Assistant.headerTitle')))]), _c('span', {
    staticClass: "assistant-chat__beta"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Assistant.beta')))])]), _c('div', {
    staticClass: "assistant-chat__subtitle"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Assistant.headerSubtitle')))])]), _c(VBtn, {
    staticClass: "assistant-chat__icon-btn assistant-chat__close",
    attrs: {
      "icon": "",
      "small": "",
      "title": _vm.$i18n_t('Common.close'),
      "aria-label": _vm.$i18n_t('Common.close')
    },
    on: {
      "click": _vm.closeChat
    }
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.accentTextColor
    }
  }, [_vm._v("fal fa-times")])], 1)], 1), _c('div', {
    staticClass: "assistant-chat__body"
  }, [_c('aside', {
    staticClass: "assistant-chat__tasks"
  }, [_c('div', {
    staticClass: "assistant-chat__tasks-header"
  }, [_c(VBtn, {
    staticClass: "assistant-chat__tasks-toggle",
    attrs: {
      "icon": "",
      "small": "",
      "title": _vm.$i18n_t('Assistant.tasks')
    },
    on: {
      "click": _vm.toggleTasks
    }
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-bars")])], 1), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.tasksCollapsed,
      expression: "!tasksCollapsed"
    }],
    staticClass: "assistant-chat__tasks-title"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Assistant.tasks')) + "\n          ")])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.tasksCollapsed,
      expression: "!tasksCollapsed"
    }],
    staticClass: "assistant-chat__tasks-list"
  }, [!_vm.tasks.length ? _c('div', {
    staticClass: "assistant-chat__tasks-empty"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Assistant.tasksEmpty')) + "\n          ")]) : _vm._e(), _vm._l(_vm.tasks, function (task) {
    return _c('div', {
      key: task.id,
      staticClass: "assistant-chat__task"
    }, [_c('div', {
      staticClass: "assistant-chat__task-header"
    }, [_c(VIcon, {
      staticClass: "mr-2",
      attrs: {
        "small": "",
        "color": _vm.taskColor(task.status)
      }
    }, [_vm._v(_vm._s(_vm.taskIcon(task.status)))]), _c('span', {
      staticClass: "assistant-chat__task-name"
    }, [_vm._v(_vm._s(task.name))])], 1), _c('div', {
      staticClass: "assistant-chat__task-status",
      class: `assistant-chat__task-status--${task.status}`
    }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t(`Assistant.taskStatus.${task.status}`)) + "\n            ")])]);
  })], 2)]), _c('section', {
    staticClass: "assistant-chat__main"
  }, [_c('div', {
    ref: "messages",
    staticClass: "assistant-chat__messages"
  }, [_vm._l(_vm.messages, function (message, index) {
    return _c('div', {
      key: `${message.role}-${index}`,
      class: ['assistant-chat__message', `assistant-chat__message--${message.role}`]
    }, [message.role === 'assistant' ? _c('div', {
      staticClass: "assistant-chat__avatar"
    }, [_c(VIcon, {
      attrs: {
        "small": "",
        "color": _vm.accentTextColor
      }
    }, [_vm._v("fal fa-robot")])], 1) : _vm._e(), _c('div', {
      staticClass: "assistant-chat__bubble"
    }, [message.role === 'assistant' ? _c('span', {
      staticClass: "assistant-chat__md",
      domProps: {
        "innerHTML": _vm._s(_vm.renderMarkdown(message.content || (_vm.sending && index === _vm.messages.length - 1 ? '…' : '')))
      }
    }) : _c('span', {
      domProps: {
        "textContent": _vm._s(message.content)
      }
    })])]);
  }), _vm.pendingAction ? _c('div', {
    staticClass: "assistant-chat__pending"
  }, [_c('div', {
    staticClass: "assistant-chat__pending-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Assistant.confirmCardTitle')) + "\n            ")]), _c('div', {
    staticClass: "assistant-chat__pending-summary"
  }, [_vm._v(_vm._s(_vm.pendingAction.summary))]), _vm._l(_vm.pendingActionPreviewEntries, function (entry) {
    return _c('div', {
      key: entry.key,
      staticClass: "assistant-chat__pending-row"
    }, [_c('span', {
      staticClass: "assistant-chat__pending-label"
    }, [_vm._v(_vm._s(entry.label))]), _c('span', {
      staticClass: "assistant-chat__pending-value"
    }, [_vm._v(_vm._s(entry.value))])]);
  }), _c('div', {
    staticClass: "assistant-chat__pending-actions"
  }, [_c(VBtn, {
    attrs: {
      "color": "primary",
      "small": "",
      "loading": _vm.confirming
    },
    on: {
      "click": _vm.confirmPendingAction
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Assistant.confirmAction')) + "\n              ")]), _c(VBtn, {
    attrs: {
      "text": "",
      "small": "",
      "disabled": _vm.confirming
    },
    on: {
      "click": _vm.dismissPendingAction
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Assistant.dismissAction')) + "\n              ")])], 1)], 2) : _vm._e()], 2), _c('footer', {
    staticClass: "assistant-chat__composer"
  }, [_c('div', {
    staticClass: "assistant-chat__composer-input"
  }, [_c(VTextarea, {
    ref: "composer",
    attrs: {
      "placeholder": _vm.$i18n_t('Assistant.composerPlaceholder'),
      "disabled": _vm.sending || _vm.confirming,
      "hide-details": "",
      "auto-grow": "",
      "rows": "1",
      "solo": "",
      "flat": "",
      "dense": "",
      "background-color": "transparent"
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) return null;
        $event.preventDefault();
        return _vm.sendMessage.apply(null, arguments);
      }
    },
    model: {
      value: _vm.draft,
      callback: function ($$v) {
        _vm.draft = $$v;
      },
      expression: "draft"
    }
  })], 1), _c('div', {
    staticClass: "assistant-chat__composer-actions"
  }, [_c(VSelect, {
    staticClass: "assistant-chat__model-select",
    attrs: {
      "items": _vm.modelProfiles,
      "item-text": "label",
      "item-value": "id",
      "label": _vm.$i18n_t('Assistant.models'),
      "disabled": _vm.sending || _vm.confirming,
      "hide-details": "",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.selectedModelProfileId,
      callback: function ($$v) {
        _vm.selectedModelProfileId = $$v;
      },
      expression: "selectedModelProfileId"
    }
  }), _c(VBtn, {
    attrs: {
      "icon": "",
      "loading": _vm.sending,
      "disabled": !_vm.canSend,
      "color": "primary",
      "data-cy": "btn_assistant_send"
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_c(VIcon, [_vm._v("fal fa-paper-plane")])], 1)], 1)])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };